import React, { useState } from 'react'
import { Popup, Modal } from 'antd-mobile'
import { CloseOutlined } from '@ant-design/icons'
import general from '../../general'
import Dialog from '../../lib/Dialog'

export default function PraiseAlert(props) {

  const [index, setIndex] = useState(0)
  const arr = ['5个', '10个', '20个']

  const rewardCommunity = () => {
    Modal.clear()
    Dialog.loading()
    general.axios.post('/rewardCommunity', {
      tagid: props.info?.tagid,
      id: props.info?.id,
      amount: arr[index].replace('个', ''),
      circles_type: props.info?.circles_type
    })
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status } = res.data;
        if (status.succeed) {
          props.handleRewardCommunity()
        }else{
          Dialog.error(status.error_desc);
        }
      })
  }

  const handlePraise = () => {
    props.handleClose()
    if (props.info?.reward?.current_amount < parseInt(arr[index])) {
      Dialog.alert('金币余额不足');
      return;
    }
    Modal.show({
      title: '温馨提示',
      closeOnMaskClick: true,
      className: 'game-sign-title',

      content: (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <div style={{ fontSize: 12, color: '#666', padding: 5 }}>确认赞赏{arr[index]}金币？</div>
          <div onClick={rewardCommunity} style={{ backgroundColor: 'var(--MainColor)', width: '183px', height: '44px', color: 'white', fontSize: '15px', textAlign: 'center', borderRadius: '22px', lineHeight: '44px', marginTop: '10px' }}>确认</div>
          <div onClick={() => {
            Modal.clear()
          }} style={{ fontSize: '13px', color: '#999', paddingTop: '10px' }}>取消</div>
        </div>
      ),
    })
  }

  return (
    <div>
      <Popup
        visible={props.visible}
        bodyStyle={{ borderTopLeftRadius: '13px', borderTopRightRadius: '13px', padding: '0 15px' }}
      >
        <div style={{ position: 'relative' }}>
          <div onClick={props.handleClose} style={{ position: 'absolute', top: 10, right: -15, padding: 15 }}>
            <CloseOutlined style={{ color: '#999' }}></CloseOutlined>
          </div>
          <div style={{ paddingTop: '30px', fontSize: 19, color: '#282828', fontWeight: 500 }}>赞赏</div>
          <div style={{ paddingTop: '10px', fontSize: 12, color: '#666' }}>支持原创，赞赏鼓励</div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', paddingTop: 15 }}>
            {arr.map((item, idx) => {
              return <div key={idx} style={{ width: '30%', borderRadius: 8, backgroundColor: index == idx ? 'var(--MainColor)' : '#F8F8F8', color: index == idx ? 'white' : '#282828', textAlign: 'center', padding: '10px 0' }} onClick={() => {
                setIndex(idx)
              }}>{item}</div>
            })}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, color: '#666', padding: 20 }}>
            <span>剩余金币：</span>
            <span style={{ color: '#F32137' }}>{props.info?.reward?.current_amount}</span>
            <span>个</span>
          </div>
          <div onClick={handlePraise} style={{ display: 'flex', justifyContent: 'center', paddingBottom: 30 }}>
            <div style={{ display: 'inline-block', backgroundColor: 'var(--MainColor)', borderRadius: 24, textAlign: 'center', padding: '10px 130px', color: 'white', fontSize: 18, fontWeight: 500 }}>赞赏支持</div>
          </div>
        </div>
      </Popup>
    </div>
  )
}
